import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { Configuration } from 'remarketing-angular-library';
import { Store } from '@ngxs/store';
import { TranslocoDirective } from '@jsverse/transloco';
import { CheckIconComponent, ErrorIconComponent } from 'remarketing-ui-components-lib';


@Component({
    selector: 'app-action-list-message-modal',
    templateUrl: './action-list-message-modal.component.html',
    styleUrls: ['./action-list-message-modal.component.scss'],
    imports: [TranslocoDirective, CheckIconComponent, ErrorIconComponent]
})
export class ActionListMessageModalComponent implements OnInit {
  private readonly _destroy$ = new Subject();

  configuration: Configuration;

  @Input() messages: Map<string, string[]>;

  successMessage = '';
  errorMessages: string[] = [];
  headerMessage = '';

  @Output()
  close = new EventEmitter();

  @Output()
  error = new EventEmitter<string>();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.successMessage =
      this.messages.get('success') && this.messages.get('success').length > 0 ? this.messages.get('success')[0] : '';
    this.errorMessages = this.messages.get('error');
    this.headerMessage =
      this.messages.get('header') && this.messages.get('header').length > 0 ? this.messages.get('header')[0] : '';
  }

  closeModal() {
    this.close.emit();
  }
}
